export class AppointmentCallRecordingPlayHistoryRequestModel {
    SchAppointmentCallRecordingPlayId: number;
    SchRecordingSid: string;
    SchCallRecordingPlayBy: number;
    SchCallRecordingPlayByUserName: string;
    SchCallRecordingPlayDateTime: Date;
  }